import React from 'react';

/**
 * Standardized section header for all pages.
 * Dark gradient banner with Underads brand red/orange gradient.
 * Design matching IB Biography / Channel Profile headers.
 */
export function SectionHeader({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="relative overflow-hidden rounded-xl mb-6 border border-[hsl(var(--border))] bg-[hsl(var(--surface))]">
      {/* Header banner with gradient */}
      <div className="px-5 lg:px-6 py-4 lg:py-5 bg-gradient-to-r from-[#E63946]/20 via-[#F97316]/15 to-transparent relative overflow-hidden">
        {/* Subtle glow overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#E63946]/10 to-transparent opacity-50" />
        
        <div className="relative flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            {/* Icon box with brand gradient and glow */}
            <div className="w-11 h-11 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#E63946]/30 to-[#F97316]/20 border border-[#E63946]/40 shadow-[0_0_20px_-5px_#E63946]">
              {Icon && <Icon size={22} className="text-white" />}
            </div>
            <div>
              <h1 className="text-xl lg:text-2xl font-bold text-white font-heading">{title}</h1>
              {subtitle && <p className="text-sm text-[hsl(var(--text-muted))]">{subtitle}</p>}
            </div>
          </div>
          {action && <div>{action}</div>}
        </div>
      </div>
    </div>
  );
}
